import { ColumnHelper } from "@tanstack/react-table";
import { ManageRolesTableDataItem } from "PFApp/activities/manage_roles/manage_roles.types";
import { RolesFormKey } from "PFApp/types/activity_form/activity_form_schema";
import { EngagementRef } from "PFCore/types";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { createBookedWmColumn } from "../parts/booked_wm_cell";
import { createEngagementColumn } from "../parts/engagement_cell";
import { createOriginalWmColumn } from "../parts/original_wm_cell";
import { createSuggestedWmColumn } from "../parts/suggested_wm_cell";
import { useCalculateEngagementRowSpan } from "./use_calculate_engagement_rowspan";

type UseManageRolesColumns = {
  rolesFormKey: RolesFormKey;
  engagements: Array<EngagementRef | undefined>;
};

export const useManageRolesColumns = ({ rolesFormKey, engagements }: UseManageRolesColumns) => {
  const { t } = useTranslation("activities", { keyPrefix: "manageRoles.columns" });

  const engagementRowSpan = useCalculateEngagementRowSpan(engagements);

  const generateColumns = useCallback(
    (columnHelper: ColumnHelper<ManageRolesTableDataItem>) => [
      createEngagementColumn(columnHelper, rolesFormKey, t("engagementName"), engagementRowSpan),
      createOriginalWmColumn(columnHelper, rolesFormKey, t("originalWm")),
      createBookedWmColumn(columnHelper, rolesFormKey, t("bookedWm")),
      createSuggestedWmColumn(columnHelper, rolesFormKey, t("suggestedWm"))
    ],
    [rolesFormKey, t, engagementRowSpan]
  );

  return { generateColumns };
};
